import React, { useMemo, useState } from "react";
import axios from "axios";
import "./DoctorApply.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://doctorisin-genesis-1-0.onrender.com";
const APPLY_URL = `${API_BASE_URL}/public/doctors/apply`;

const DoctorApply: React.FC = () => {
  const year = useMemo(() => new Date().getFullYear(), []);
  const [busy, setBusy] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [specialties, setSpecialties] = useState("");
  const [medical_license_number, setMedicalLicenseNumber] = useState("");
  const [country, setCountry] = useState("");
  const [website, setWebsite] = useState("");
  const [bio, setBio] = useState("");
  const [photo, setPhoto] = useState<File | null>(null);

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSuccessMsg("");
    setErrorMsg("");

    if (!name.trim() || !email.trim()) {
      setErrorMsg("Name and email are required.");
      return;
    }

    try {
      setBusy(true);

      const form = new FormData();
      form.append("name", name.trim());
      form.append("email", email.trim());
      if (specialties.trim()) form.append("specialties", specialties.trim());
      if (medical_license_number.trim()) form.append("medical_license_number", medical_license_number.trim());
      if (country.trim()) form.append("country", country.trim());
      if (website.trim()) form.append("website", website.trim());
      if (bio.trim()) form.append("bio", bio.trim());
      if (photo) form.append("photo", photo);

      const res = await axios.post(APPLY_URL, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setSuccessMsg(`Application submitted. Status: ${res.data?.status ?? "Pending"}`);

      setName("");
      setEmail("");
      setSpecialties("");
      setMedicalLicenseNumber("");
      setCountry("");
      setWebsite("");
      setBio("");
      setPhoto(null);
    } catch (err: any) {
      const detail = err?.response?.data?.detail;
      setErrorMsg(detail || "Submission failed. Check backend logs.");
      console.error(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="apply-container">
      <div className="apply-card">
        <h2 className="apply-title">Doctor Beta Registration</h2>
        <div className="apply-tagline">Doctor AI with a human touch.</div>

        <form onSubmit={onSubmit} className="apply-form">
          <div className="apply-grid">
            <div className="apply-field">
              <label>Name *</label>
              <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Full name" />
            </div>

            <div className="apply-field">
              <label>Email *</label>
              <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address" />
            </div>

            <div className="apply-field">
              <label>Specialty</label>
              <input value={specialties} onChange={(e) => setSpecialties(e.target.value)} placeholder="Pediatrics, General Practice..." />
            </div>

            <div className="apply-field">
              <label>Medical License Number</label>
              <input value={medical_license_number} onChange={(e) => setMedicalLicenseNumber(e.target.value)} placeholder="License #" />
            </div>

            <div className="apply-field">
              <label>Country</label>
              <input value={country} onChange={(e) => setCountry(e.target.value)} placeholder="Country" />
            </div>

            <div className="apply-field">
              <label>Website</label>
              <input value={website} onChange={(e) => setWebsite(e.target.value)} placeholder="Website URL" />
            </div>

            <div className="apply-field apply-field-wide">
              <label>Bio</label>
              <textarea value={bio} onChange={(e) => setBio(e.target.value)} placeholder="Short bio (optional)" rows={4} />
            </div>

            <div className="apply-field apply-field-wide">
              <label>Photo (optional)</label>
              <input type="file" accept="image/*" onChange={(e) => setPhoto(e.target.files?.[0] || null)} />
            </div>
          </div>

          {successMsg ? <div className="apply-msg success">{successMsg}</div> : null}
          {errorMsg ? <div className="apply-msg error">{errorMsg}</div> : null}

          <button className="apply-btn" type="submit" disabled={busy}>
            {busy ? "Submitting..." : "Submit Application"}
          </button>
        </form>

        <div className="apply-footer">© {year} Doctor Is In App. All rights reserved.</div>
      </div>
    </div>
  );
};

export default DoctorApply;

